/**
 * Hero section Swiper initialization and anchor link scroll functionality
 * Handles Swiper slider initialization with autoplay, loop, and pagination
 * Also handles smooth scrolling when hero button links to page anchors
 */

// Listen for lottie-hero-show event to reveal hero content at frame 30
window.addEventListener('lottie-hero-show', () => {
  const heroContentElements = document.querySelectorAll('.js-hero-content');
  heroContentElements.forEach(element => {
    // eslint-disable-next-line no-param-reassign
    element.style.opacity = '1';
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const heroSwiperElement = document.querySelector('.hero-swiper');

  // Initialize Swiper if element exists
  if (heroSwiperElement) {
    const autoplayEnabled =
      heroSwiperElement.dataset.autoplayEnabled === 'true';
    const autoplayDelay =
      parseInt(heroSwiperElement.dataset.autoplayDelay, 10) || 3000;

    const swiperConfig = {
      loop: true,
      spaceBetween: 0,
      slidesPerView: 1,
      pagination: {
        el: '.swiper-pagination',
        type: 'progressbar',
      },
      grabCursor: true,
      keyboard: {
        enabled: true,
      },
      mousewheel: {
        invert: false,
        forceToAxis: true,
      },
      // Accessibility
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        firstSlideMessage: 'This is the first slide',
        lastSlideMessage: 'This is the last slide',
      },
    };

    // Add autoplay if enabled
    if (autoplayEnabled) {
      swiperConfig.autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: false,
      };
    }

    // eslint-disable-next-line no-new, no-undef
    new Swiper('.hero-swiper', swiperConfig);
  }

  // Handle anchor link scroll functionality for hero buttons
  const heroButtons = document.querySelectorAll('.js-hero-button');

  heroButtons.forEach(heroButton => {
    heroButton.addEventListener('click', e => {
      const href = heroButton.getAttribute('href');

      // Check if the link is an anchor link (starts with #)
      if (href && href.startsWith('#')) {
        e.preventDefault();

        const targetId = href.substring(1);
        let targetElement = document.getElementById(targetId);

        // Fallback: Try partial ID match if exact match not found
        if (!targetElement) {
          targetElement = document.querySelector(`[id*="${targetId}"]`);
        }

        if (targetElement) {
          // Calculate offset for sticky header
          const header = document.querySelector('.js-sticky-header');
          const headerHeight = header ? header.offsetHeight : 0;
          const elementPosition =
            targetElement.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - headerHeight - 20;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
          });
        }
      }
    });
  });
});
